import Information from './information';

export const information = {
  firstLevel:  Information,
  secondLevel: Information,
};